<template>
	<div class="p-fluid p-component p-formgrid p-grid p-input-filled">
		<div class="p-field p-col-12">
			<label for="keyword">{{$t('Squeeze.Locators.Tabs.KeyWords')}} *</label>
			<InputText id="keyword" v-model="value.keyword" :class="{'p-invalid':v$.keyword.$invalid && showErrorMessage}" @change="update" required="true" autofocus />
			<small v-if="v$.keyword.$invalid && showErrorMessage" class="p-error">
				{{ $t('Forms.Val.MissingRequired', { field: $t('Squeeze.Locators.Tabs.KeyWords')}) }}
			</small>
		</div>
	</div>
</template>

<script lang="ts">
import {defineComponent, onMounted, PropType, reactive, watch} from "vue";
import InputText from "primevue/inputtext";
import {LocatorKeyword} from "@dex/squeeze-client-ts";
import { required } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
import {FormState} from "@/util/Types";

type LocatorKeywordFormState = FormState<LocatorKeyword, "keyword">;

export default defineComponent({
	name: "KeyWordsForm",
	components: {
		InputText,
	},
	props: {
		keyword: {
			type: Object as PropType<LocatorKeyword>,
			required: true,
		},
		showErrorMessage: {
			type: Boolean,
		},
	},
	emits: ['update'],
	setup(props, {emit}) {
		/** Current Object of all input-fields */
		const value = reactive<LocatorKeywordFormState>({keyword: ''});

		/** Determines the required rules for validation */
		const rules = {keyword: { required }}

		/** Use Vuelidate */
		const v$ = useVuelidate(rules, value);

		onMounted(() => {
			Object.assign(value, props.keyword);
			emit("update", value, v$.value.$invalid);
		});

		/** Watch prop at set value object, because props are not allowed to be mutated */
		watch(props.keyword, () => {
			Object.assign(value, props.keyword);
		})

		/** Triggered on change of any field */
		const update = () => {
			emit("update", value, v$.value.$invalid);
		}

		return {
			value,
			props,
			v$,
			InputText,
			update,
		}
	},
});

</script>

<style scoped>

</style>

